import communityIndustryExpertsEduTainment from './contentfulExports/communityIndustryExpertsEduTainment';

const useIndustryExpertsEduTainment = () => {
  return communityIndustryExpertsEduTainment;
}

export default useIndustryExpertsEduTainment;
